import React from 'react';
import {
    Snackbar,
    Alert,
    Button,
    Box,
    Typography,
} from '@mui/material';
import { LogOut, AlertTriangle } from 'lucide-react';

const SessionExpiredToast = ({ open, onLoginAgain }) => {
    return (
        <Snackbar
            open={open}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={null} // Keep open until user clicks button
            sx={{
                '& .MuiSnackbarContent-root': {
                    padding: 0,
                },
                '& .MuiAlert-root': {
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                    minWidth: '450px',
                    maxWidth: '600px',
                    padding: '16px 20px',
                    animation: 'slideUp 0.3s ease-out',
                },
                '@keyframes slideUp': {
                    '0%': {
                        transform: 'translateY(100px)',
                        opacity: 0,
                    },
                    '100%': {
                        transform: 'translateY(0)',
                        opacity: 1,
                    },
                },
            }}
        >
            <Alert
                severity="warning"
                sx={{
                    backgroundColor: '#FFF3CD',
                    color: '#856404',
                    border: '1px solid #FFEAA7',
                    '& .MuiAlert-icon': {
                        color: '#856404',
                    },
                }}
                icon={<AlertTriangle size={20} />}
                action={
                    <Button
                        onClick={onLoginAgain}
                        variant="contained"
                        size="small"
                        startIcon={<LogOut size={16} />}
                        sx={{
                            backgroundColor: '#772EDD',
                            color: '#fff',
                            textTransform: 'none',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            marginLeft: '12px',
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: '#6a25c6',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        Log In Again
                    </Button>
                }
            >
                <Box>
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ marginBottom: '4px' }}>
                        Session Expired
                    </Typography>
                    <Typography variant="body2">
                        Your session has expired for security reasons. Please log in again to continue.
                    </Typography>
                </Box>
            </Alert>
        </Snackbar>
    );
};

export default SessionExpiredToast;